import { CSSProperties } from 'react';

export const getPaperStyle = (): CSSProperties => ({
  height: '100%',
});
